import { Color3, Mesh } from '@babylonjs/core';

/**
 * Apply the cel-shaded ink outline to a vehicle mesh. Shared across Car, Motorcycle,
 * RemotePlayer, and any future vehicle so the whole fleet has a consistent look.
 *
 * `width` is in world units. Defaults to a bold ~0.04 for the main chassis shapes; pass a
 * smaller value for thin parts like wheels so the outline doesn't visually fatten them.
 */
export function applyInkOutline(mesh: Mesh, width = 0.04): void {
  mesh.renderOutline = true;
  mesh.outlineColor = new Color3(0, 0, 0);
  mesh.outlineWidth = width;
}
